import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import sw from './locales/sw.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sw: { translation: sw },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'sw'],
    detection: {
      // Follow the browser by default; remember an explicit choice from
      // the language switcher across sessions.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'seller_language',
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
